import React from "react";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import { makeStyles } from "tss-react/mui";

import ButtonUI from "./ButtonUI";

const useStyles = makeStyles()({
  dialogPaper: {
    "& .MuiPaper-root": {
      // maxWidth: "710px",
      // maxWidth: "420px",
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
    },
    "& .MuiGrid-item": {
      paddingTop: "15px",
    },
    "& .MuiGrid-item .MuiTextField-root": {
      marginTop: 0,
    },
    "& .MuiDivider-root": {
      marginTop: "5px",
      marginBottom: "9px",
    },
    "& .MuiDialogActions-root": {
      padding: "0 20px 10px 0",
    },
  },
  formContainer: {
    display: "grid",
    width: "100%",
    textAlign: "left",
    minHeight: "110px",
  },
  container: {
    backgroundColor: "#FFFFFF",
  },
  Toolbar: {
    fontSize: "1.1rem",
    backgroundColor: "white",
    color: "black",
  },
});

// Open Confirm Popup
const ConfirmPopup = ({ configData }) => {
  const { classes } = useStyles();
  const {
    maxWidth,
    handleCancel,
    popupTitle,
    loadingForConfirm,
    minHeight,
    popupMessage,
    handleClick,
    confirmBtnColor,
    disableSave,
    confirmBtnName,
  } = configData;

  return (
    <Dialog className={classes.dialogPaper} open={true} maxWidth={maxWidth || "md"} onClose={() => handleCancel()}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>{popupTitle} </Toolbar>
      </AppBar>
      <Box
        sx={{
          width: "100%",
          maxWidth: maxWidth ? maxWidth : "900px",
        }}
        className={classes.container}
      >
        <Backdrop
          sx={{
            backgroundColor: "transparent",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={!!loadingForConfirm}
        >
          <CircularProgress color="primary" />
        </Backdrop>
        <Box
          sx={{
            width: "100%",
            minHeight: minHeight ? minHeight : "110px",
          }}
          component="form"
          className={classes.formContainer}
        >
          <DialogContent>
            {typeof popupMessage === "string" ? (
              <DialogContentText id="alert-dialog-slide-description">{popupMessage}</DialogContentText>
            ) : (
              popupMessage
            )}
          </DialogContent>
          <DialogActions>
            <ButtonUI variant="contained" color="secondary" onClick={handleCancel}>
              Cancel
            </ButtonUI>
            <ButtonUI
              onClick={() => {
                handleClick();
              }}
              variant="contained"
              color={confirmBtnColor ? confirmBtnColor : "success"}
              style={{ marginLeft: 15 }}
              disabled={loadingForConfirm || disableSave}
            >
              {confirmBtnName ? confirmBtnName : "Ok"}
            </ButtonUI>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
};

export default React.memo(ConfirmPopup);
